import React from "react";
import type { TickerPosition } from "@bloomberg/octagon-shared";
import styles from "./holdingsDrawer.module.css";
import {
  formatWithCommasAndDecimals,
  formatMoneyWithLeadingPlusOrMinus,
} from "~utils/portfolio/formatNumber";

type DrawerOverviewProps = {
  readonly position: TickerPosition | null;
};

export default function DrawerOverview({ position }: DrawerOverviewProps) {
  const lots = position?.lots.length ?? null;
  const shares = position
    ? position.lots.reduce((sum, l) => sum + l.shares, 0)
    : null;
  const avgCost = position?.marketValue.averageBuyPrice ?? null;
  const totalGainLoss = position?.marketValue.totalGainLoss ?? null;

  return (
    <section>
      <h3 className={styles.sectionTitle}>Overview</h3>
      <div className={styles.overviewGrid}>
        <div className={styles.overviewItem}>
          <span className={styles.overviewLabel}>Lots</span>
          <span className={styles.overviewValue}>{lots ?? "—"}</span>
        </div>
        <div className={styles.overviewItem}>
          <span className={styles.overviewLabel}>Shares</span>
          <span className={styles.overviewValue}>{shares ?? "—"}</span>
        </div>
        <div className={styles.overviewItem}>
          <span className={styles.overviewLabel}>Avg Cost</span>
          <span className={styles.overviewValue}>
            {avgCost !== null ? formatWithCommasAndDecimals(avgCost) : "—"}
          </span>
        </div>
        <div className={styles.overviewItem}>
          <span className={styles.overviewLabel}>Total Gain</span>
          <span className={styles.overviewValue}>
            {totalGainLoss !== null
              ? formatMoneyWithLeadingPlusOrMinus(totalGainLoss)
              : "—"}
          </span>
        </div>
      </div>
    </section>
  );
}
